export default "__VITE_ASSET__2623cc6a__"